import { render } from "./ViewStock.vue?vue&type=template&id=0a2a94aa"
import script from "./ViewStock.vue?vue&type=script&lang=js"
export * from "./ViewStock.vue?vue&type=script&lang=js"

import "./ViewStock.vue?vue&type=style&index=0&id=0a2a94aa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__